// import Button from '@material-ui/core/Button'
// import Dialog from '@material-ui/core/Dialog'
import PropTypes from 'prop-types'
import React from 'react'
import Clear from '@material-ui/icons/Clear'
import { IconButton, Grid } from '@material-ui/core'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { StyledDialogContent, StyledDialogTitle, StyledDialog, DialogContainer } from '../../theme/Global'
import { modalClose } from '../actions'

export const Modal = ({
  disableBackdropClick,
  component,
  open,
  modalCloseDispatch,
  title,
  isFullWidth,
  maxWidth,
  maxStyleWidth,
  unsetHeight,
  customBackgroundColor,
  styles
}) => {
  return (
    <StyledDialog
      customBackgroundColor={customBackgroundColor}
      fullWidth={isFullWidth}
      maxWidth={maxWidth === '' ? false : maxWidth}
      onClose={modalCloseDispatch}
      open={open}
      disableBackdropClick={disableBackdropClick}
    >
      <DialogContainer style={styles}>
        {title ? (
          <StyledDialogTitle>
            <Grid container justify="space-between" alignContent="center" style={{ height: '100%' }}>
              <p id="modalTitle">{title}</p>
              <IconButton onClick={modalCloseDispatch} color="inherit" aria-label="Exit dialog">
                <Clear style={{ height: '32px', width: '32px' }} />
              </IconButton>
            </Grid>
          </StyledDialogTitle>
        ) : null}
        <StyledDialogContent style={unsetHeight ? { minHeight: 'unset' } : {}}>
          {component}
        </StyledDialogContent>
      </DialogContainer>
    </StyledDialog>
  )
}

const mapStateToProps = (state) => ({
  component: state.common.modalComponent,
  open: state.common.modalOpen,
  title: state.common.modalTitle,
  disableBackdropClick: state.common.modalPayload.disableBackdropClick,
  isFullWidth: state.common.modalPayload.isFullWidth,
  unsetHeight: state.common.modalPayload.unsetHeight,
  maxWidth: state.common.modalPayload.maxWidth
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  { modalCloseDispatch: modalClose },
  dispatch
)

Modal.propTypes = {
  component: PropTypes.element,
  modalCloseDispatch: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  maxWidth: PropTypes.string,
  isFullWidth: PropTypes.bool,
  disableBackdropClick: PropTypes.bool
}

Modal.defaultProps = {
  component: null,
  title: '',
  maxWidth: '',
  isFullWidth: false,
  unsetHeight: false
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Modal)
